import { MdDeleteOutline } from "react-icons/md";
import CartonInfoBox from "../Cart/CartonInfoBox";

export default function Addeditems({ items, containerRef, onRemove }) {
  debugger
  if (!items || items.length === 0) {
    return null;
  }


  // تبدیل انگلیسی به فارسی
  const toPersianDigits = (str) => {
    return str.replace(/\d/g, (d) => String.fromCharCode(d.charCodeAt(0) + 1728));
  };

  if (!items) return null;
  return (
    <div
      ref={containerRef}
      className="mt-4 space-y-2"
    >
      {items.map((item) => {
        const isCarton= item.weight === "کارتن";
        const isPowder= item.weight === "آسیاب";
        return (
          <div
            key={item.id}
            className="
          flex itemss-center justify-between
          bg-white
          border border-slate-200
          rounded-xl
          px-4 py-3
          shadow-sm
        "
          >
            <div className="flex itemss-center gap-3">
              <img
                src={item.image}
                alt={item.title}
                className="w-10 h-10 rounded-lg object-cover"
              />

              <div>
                <p className="text-sm font-semibold text-slate-800">
                  {item.weight}
                </p>

                <p className="text-xs text-slate-400">
                  {toPersianDigits(String(item.quantity))} {isPowder?"گرم":"عدد"}
                </p>
              </div>

              {isCarton && (
                  <div className="mt-2.5">
                    <CartonInfoBox />
                  </div>
                )}
            </div>
            <button
              type="button"
              onClick={() => onRemove(item.id, item.weight)}
              className="
                text-red-500
                hover:text-red-700
                hover:bg-red-50
                rounded-lg
                p-2
                transition
              "
              title="حذف"
            >
              <MdDeleteOutline size={20} />
            </button>
          </div>
        )
      }
      )}
    </div>
  );
}